/**
 * Back to Top Component
 * Smoothly scrolls to top of page when button is clicked
 * Shows/hides based on scroll position
 */

(function () {
  'use strict';

  function initBackToTop() {
    const backToTopButton = document.querySelector('[data-back-to-top]');
    const backToTopSection = document.querySelector('.back-to-top');

    if (!backToTopButton || !backToTopSection) return;

    // Get settings from section data attributes or defaults
    const sectionWrapper = backToTopSection.closest('.section-back-to-top-wrapper') || backToTopSection;
    const scrollOffset = sectionWrapper?.dataset?.scrollOffset
      ? parseInt(sectionWrapper.dataset.scrollOffset, 10)
      : 0;
    const smoothScroll = sectionWrapper?.dataset?.smoothScroll !== 'false';

    // Show/hide button based on scroll position
    function toggleVisibility() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const showThreshold = 300; // Show after scrolling 300px

      if (scrollY > showThreshold) {
        backToTopSection.classList.remove('is-hidden');
        backToTopButton.setAttribute('aria-hidden', 'false');
      } else {
        backToTopSection.classList.add('is-hidden');
        backToTopButton.setAttribute('aria-hidden', 'true');
      }
    }

    // Scroll to top function
    function scrollToTop(e) {
      e.preventDefault();

      const targetY = scrollOffset;
      const currentY = window.pageYOffset || document.documentElement.scrollTop;
      const distance = currentY - targetY;
      const duration = smoothScroll ? Math.min(800, Math.abs(distance) * 0.5) : 0;
      const startTime = performance.now();

      if (!smoothScroll || duration === 0) {
        window.scrollTo(0, targetY);
        return;
      }

      function animateScroll(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function (ease-in-out)
        const ease = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        window.scrollTo(0, currentY - distance * ease);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      }

      requestAnimationFrame(animateScroll);
    }

    // Event listeners
    backToTopButton.addEventListener('click', scrollToTop);

    // Throttled scroll listener for performance
    let ticking = false;
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          toggleVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial check
    toggleVisibility();

    // Re-initialize on section load (Theme Editor support)
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId && sectionWrapper) {
        const sectionId = sectionWrapper.getAttribute('data-section-id');
        if (sectionId === event.detail.sectionId) {
          toggleVisibility();
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop);
  } else {
    initBackToTop();
  }
})();
